import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Address, FoehnConfirmModalService } from '@dsivd/prestations-ng';

import { RecapSection, RecapSectionElement } from './recap-section.type';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'recap-section',
    templateUrl: './recap-section.component.html',
    styles: [`
        .recap-badge {
            display: inline-block;
            padding: .25em .4em;
            line-height: 1;
            text-align: center;
            white-space: nowrap;
            vertical-align: baseline;
            text-decoration: none;
            cursor: pointer;
            transition: color .15s ease-in-out,
            background-color .15s ease-in-out,
            border-color .15s ease-in-out,
            box-shadow .15s ease-in-out;
        }
    `]

})
export class RecapSectionComponent<T> {

    @Input()
        data: RecapSection;

    @Input()
        acceptEmptyValues = false;

    @Input()
        actionsText = 'Actions';

    @Input()
        canEdit = false;

    @Input()
        editText = 'Editer';

    @Input()
        canDelete = false;

    @Input()
        deleteText = 'Supprimer';

    @Input()
        onDeleteConfirmDialogText = 'Souhaitez-vous vraiment supprimer cet élément ?';

    @Output()
        delete = new EventEmitter<void>();

    @Output()
        edit = new EventEmitter<void>();

    constructor(private confirmModalService: FoehnConfirmModalService) {
    }

    private static fixLineBreaks(value: any): string {
        if (!value || typeof value.replace !== 'function') {
            return value;
        }

        return value.replace(/\r?\n|\r/g, '<br/>');
    }

    private static isSet(value: any): boolean {
        return !!value || value === 0;
    }

    cleanValue(element: RecapSectionElement): string {
        return RecapSectionComponent.fixLineBreaks(this.formatEmptyValue(element));
    }

    atLeastOneElementHasContent(data: RecapSection): boolean {
        if (!data) {
            return false;
        }

        return data.elements.some(element => this.hasContent(element));
    }

    hasContent(element: RecapSectionElement): boolean {
        return (
            !!element &&
            (this.acceptEmptyValues ||
                element.acceptEmptyValue ||
                RecapSectionComponent.isSet(element.value))
        );
    }

    buildId(element: RecapSectionElement): string {
        if (!element) {
            return null;
        }

        // To instrument the DOM for automated testing, an ID is required
        // on the value (dd).
        return element.id || `${this.data.titleKey || ''}.${element.key || ''}`;
    }

    isAddress(element: RecapSectionElement): boolean {
        if (!element) {
            return null;
        }


        // instanceof work only with interface (See https://stackoverflow.com/questions/45964008/typescript-instanceof-not-working/47204039#47204039).
        // But we can check if value is object and has properties mandatory for an address
        if (!!element.value && typeof element.value === 'object') {
            return (
                element.value.hasOwnProperty('country') &&
                element.value.hasOwnProperty('locality') &&
                element.value.hasOwnProperty('street')
            );
        }

        return false;
    }

    hasActionsAvailable(): boolean {
        return this.canEdit || this.canDelete;
    }

    doEdit(): void {
        this.edit.next();
    }

    doDelete(): void {
        this.confirmModalService
            .openConfirmModal({
                htmlContent: this.onDeleteConfirmDialogText
            })
            .then(
                () => {
                    this.delete.next();
                },
                () => {
                }
            );
    }

    private formatEmptyValue(element: RecapSectionElement): Address | string | number {
        return (this.acceptEmptyValues || element.acceptEmptyValue) &&
        !RecapSectionComponent.isSet(element.value)
            ? '-'
            : element.value;
    }

}
